export const PremiumFeatureIconName = 'asterisk';
export const PremiumFeatureIconClass = 'text-info group-disabled:text-passive-2';
